import { Component } from '@angular/core';
import { BaseAdvancedPropertyViewComponent } from '../base-advanced-property-view.component';
import { NonUsableSpaceComponent } from 'src/app/models/components/objectComponents/NonUsableSpaceComponent';
import { MatDialogRef } from '@angular/material/dialog';
import { InputHelper } from 'src/app/helper/inputHelper';

@Component({
  selector: 'app-nonuseablespace',
  templateUrl: './nonuseablespace.component.html',
  styleUrls: ['./nonuseablespace.component.css']
})
export class NonUseablespaceViewComponent extends BaseAdvancedPropertyViewComponent {
  // currently not used since the non usable space object has no specific properties
  nonUsableSpace:NonUsableSpaceComponent
  integerOnly = InputHelper.integerOnly;

  constructor(public dialogRef: MatDialogRef<BaseAdvancedPropertyViewComponent>) {
    super(dialogRef);
    dialogRef.disableClose = true;
  }

  ngOnInit() {

  }

  saveButtonDisabledState():boolean{
    return false;
  }
}
